import Container from "../element/container";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Image from "../element/image";
import { DcLogo } from "../../assets/images";
import "./footer.scss";
import { phoneNumbers, socialLinks } from "../../content/contact";

const serviceLinks = [
  "Buy Car",
  "Sell Car",
  "Our Panel Workshop",
  "Insurance",
  "Dealership Program",
];

const footerRoutes = {
  "Buy Car": "/#home-product-list",
  "Sell Car": "/consign",
  "Our Panel Workshop": "/workshop",
  "About Us": "/about-us",
  Blog: "/blog",
  Careers: "/careers",
  Insurance: "/insurance",
  "Dealership Program": "/dealership-program",
  "Privacy Policy": "/privacy-policy",
  "Terms & Conditions": "/terms-and-conditions",
};

const companyLinks = [
  "About Us",
  "Blog",
  "Careers",
  "Privacy Policy",
  "Terms & Conditions",
];

export default function Footer({ hideAddress = false }) {
  const { t } = useTranslation();

  return (
    <footer className="site-footer">
      <Container tag="div" className="site-footer-grid">
        <section className="site-footer-brand">
          <Image src={DcLogo} alt="DCAR" className="_img site-footer-logo" />
          <p className="site-footer-description">
            {t(
              "We Are Fast Growing Luxury Car Consignment Company in Malaysia, our mission is allow you Sell or Buy car with hassel free",
            )}
          </p>

          <address className="site-footer-contact">
            <Container tag="div" className="footer-phone-numbers">
              <Icon icon="solar:phone-calling-bold" />
              <span>
                {phoneNumbers.map((phone, i) => (
                  <span key={phone.href}>
                    {i > 0 && <span aria-hidden="true"> / </span>}
                    <a href={phone.href}>{phone.label}</a>
                  </span>
                ))}
              </span>
            </Container>
            <a href="mailto:Support@dcar.my">
              <Icon icon="solar:letter-bold" />
              <span>Support@dcar.my</span>
            </a>
            {!hideAddress && (
              <p>
                <Icon icon="solar:map-point-bold" />
                <span>
                  {t("No7, Jalan Astana F/KU2,")}
                  <br />
                  {t("Bandar Bukit Raja, 41050 Klang, Selangor,")}
                  <br />
                  {t("Malaysia")}
                </span>
              </p>
            )}
          </address>
        </section>

        <FooterColumn t={t} title="Service" links={serviceLinks} />
        <FooterColumn t={t} title="About DCar" links={companyLinks} />

        <section className="site-footer-column site-footer-social">
          <h3>{t("Follow Us in")}</h3>
          <span className="site-footer-rule" />
          <Container tag="div" className="site-footer-social-list">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noreferrer"
                aria-label={social.label}
              >
                <Icon icon={social.icon} />
              </a>
            ))}
          </Container>
        </section>
      </Container>

      <Container tag="div" className="site-footer-bottom">
        <Container tag="div" className="footer-issuer">

          <Container tag="div">
            <p>DCH Automobile Sdn Bhd</p>
            <span>202301046619 (1540533-U)</span>
          </Container>
        </Container>
        <Container tag="div" className="footer-copyright">
          <p>
            © {new Date().getFullYear()} DCAR. {t("All Rights Reserved.")}
          </p>
          {process.env.REACT_APP_VERSION && (
            <span className="site-footer-version">
              {t("Version")} {process.env.REACT_APP_VERSION}
            </span>
          )}
        </Container>
      </Container>
    </footer>
  );
}

function FooterColumn({ t, title, links }) {
  return (
    <section className="site-footer-column">
      <h3>{t(title)}</h3>
      <span className="site-footer-rule" />
      <nav>
        {links.map((link) =>
          footerRoutes[link] ? (
            <Link to={footerRoutes[link]} key={link}>
              {t(link)}
            </Link>
          ) : (
            <a href="/" key={link} onClick={(event) => event.preventDefault()}>
              {t(link)}
            </a>
          ),
        )}
      </nav>
    </section>
  );
}
